// extracted by mini-css-extract-plugin
export default {"centerText":"AuthLinkButton__centerText___AEV2p"};